const CONFIG = {
    PORTAL_URL: "https://www.canarabank.bank.in",
    CLIENT_ID: "id-aa542798-ccfe-94dc-4410-da4ef3ba59aa",
    CLIENT_SECRET: "secret-5bbd9014-5795-76c8-168e-509d2bbfa2ba",
    PARENT_FOLDER_NAME: "States Pdf",
     USER_NAME: "mahendra@creanttechnologies.com",
    PASSWORD: "Test",

    BASE_URL: window.location.origin
};

export default CONFIG;
